export enum CalendarView {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Agenda = "agenda",
}

export enum UserType { // TODO: replace it with UserRoles from src/latest/src/constants/UserConstant.ts
  Therapist = 'THERAPIST',
  Clinician = 'CLINICIAN'
}

export enum UserStatus {
  SuccessfulOnboarding = 'SUCCESSFULL_ONBOARDING',
}